import PublicPageSection from './publicPageSection';

// Označenie obalu = verejná stránka obalu a jej QR kód (QR kód sa fyzicky tlačí na obal
// ako forma jeho označenia).
const MarkingTab = ({ unit }) => (
    <div>
        <PublicPageSection unit={unit} />
    </div>
);

export default MarkingTab;
